import { useEffect, useState } from "react";
import { subscribeToOfficeHolders } from "../services/officeService";

const LeadershipPage = () => {
  const [members, setMembers] = useState([]);

  useEffect(() => {
    const unsubscribe = subscribeToOfficeHolders((items) => setMembers(items));
    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, []);

  const renderMemberCard = (member) => (
    <article key={member.id} className="leadership-card">
      {member.photoUrl && (
        <div className="leadership-photo">
          <img
            src={member.photoUrl}
            alt={member.nameEnglish || member.nameHindi}
          />
        </div>
      )}
      <div className="leadership-card-content">
        <h3>{member.nameHindi}</h3>
        <span className="caption">{member.nameEnglish}</span>
        <p>{member.roleHindi}</p>
        <span className="caption">{member.roleEnglish}</span>
      </div>
    </article>
  );

  return (
    <section className="leadership-page">
      <header>
        <h2>वर्तमान पदाधिकारी</h2>
        <span className="caption">Current Office Bearers</span>
        <p>
          आर्य समाज अबोहर की कार्यकारिणी धर्म, सेवा और शिक्षा के मूल्यों को
          जन-जन तक पहुँचाने हेतु समर्पित है।
        </p>
        <span className="caption">
          The executive committee is devoted to spreading the values of dharma,
          service, and education across the community.
        </span>
      </header>

      {members.length === 0 && <p>पदाधिकारियों की सूची अद्यतन की जा रही है।</p>}

      {members.length > 0 && (
        <>
          <div className="leadership-featured">
            {renderMemberCard(members[0])}
          </div>
          {members.length > 1 && (
            <div className="leadership-grid">
              {members.slice(1).map((member) => renderMemberCard(member))}
            </div>
          )}
        </>
      )}
    </section>
  );
};

export default LeadershipPage;
